import { useState } from 'react';
import { Box, Icon, Tooltip } from '@nimbus-ds/components';
import { SidebarIcon, TiendanubeIcon } from '@nimbus-ds/icons';
import { useTranslationCommon } from 'commons/hooks';
import { logEvent } from 'commons/utils/tracking';
import {
  MENU_COLLAPSE_TOGGLE_COLLAPSE,
  MENU_COLLAPSE_TOGGLE_EXPAND,
} from 'config/trackingEvents';

interface MenuExpandToggleProps {
  expanded: boolean;
  onToggle: () => void;
}

export function MenuExpandToggle({
  expanded,
  onToggle,
}: Readonly<MenuExpandToggleProps>) {
  const t = useTranslationCommon('menu.header');
  const [hovered, setHovered] = useState(false);

  const handleToggle = () => {
    logEvent(
      expanded ? MENU_COLLAPSE_TOGGLE_COLLAPSE : MENU_COLLAPSE_TOGGLE_EXPAND,
      {},
    );
    onToggle();
    setHovered(false);
  };

  if (expanded) {
    return (
      <Tooltip content={t('collapseMenu')} arrow position="right">
        <Box
          as="button"
          backgroundColor={{
            hover: 'primary-surface',
            md: 'transparent',
          }}
          borderRadius="2"
          cursor="pointer"
          onClick={handleToggle}
          p="2"
          role="button"
          aria-label={t('collapseMenu')}
        >
          <Icon source={<SidebarIcon />} color="neutral-textHigh" />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip content={t('expandMenu')} arrow position="right">
      <Box
        as="button"
        backgroundColor={{
          hover: 'primary-surface',
          md: 'transparent',
        }}
        borderRadius="2"
        cursor="pointer"
        onClick={handleToggle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        p={hovered ? '3' : '2'}
        role="button"
        aria-label={t('expandMenu')}
      >
        <Icon
          source={hovered ? <SidebarIcon /> : <TiendanubeIcon size={24} />}
          color={hovered ? 'neutral-textHigh' : 'primary-interactive'}
        />
      </Box>
    </Tooltip>
  );
}
